import React, { useState } from 'react'
import "./Upgraded_profile_form.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { Form } from 'react-bootstrap'
import Proceed_btn from '../../../common_components/common_btn/proceed_btn/Proceed_btn'
import Successfull_horizontal_Modal from '../../../common_components/common_modal/successfull_horizontal_Modal/Successfull_horizontal_Modal'
import Success_horozontal_Lottie from '../../../animations/success_horozontal_Lottie/Success_horozontal_Lottie'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function Upgraded_profile_form() {
    const [phone, setPhone] = useState('');
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <>
            <section className='Upgraded_profile_form'>
                <div className="container">
                    <div className='Personal_details_tab_content'>
                        <div className="profile_form_holder">
                            <Form>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="edit_icon_holder">
                                            <FontAwesomeIcon className='edit_icon' icon={faPenToSquare} />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter First Name" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Last Name" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control type="email" placeholder="Enter Email" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mobile Number</Form.Label>
                                            <PhoneInput
                                                country={'us'}
                                                value={phone}
                                                onChange={(phone) => setPhone(phone)}
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className="col-12 text-center mt-5">
                                        <Proceed_btn btnText="Save Changes" onClick={() => setModalShow(true)} />
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </section>

            <Successfull_horizontal_Modal
                show={modalShow}
                message=" Profile Updated! "
                subMessage="Your details have been saved successfully."
                onHide={() => setModalShow(false)}
                lottie={<Success_horozontal_Lottie />}
            />
        </>
    )
}

export default Upgraded_profile_form